// extracted by mini-css-extract-plugin
export var animeIcon = "Item-module--animeIcon--mt98-";
export var icon = "Item-module--icon--wx7kj";
export var iconWrap = "Item-module--iconWrap--viMhf";
export var iconWrap__inner = "Item-module--iconWrap__inner--kfwLf";
export var item = "Item-module--item--rDkx0";
export var item__text = "Item-module--item__text--OGujG";
export var item__text__subtitle = "Item-module--item__text__subtitle--bs0Nj";
export var item__text__title = "Item-module--item__text__title--09QHJ";